/* unplugin-vue-components disabled */import script from "./MessageNotice.vue?vue&type=script&setup=true&name=MessageNotice&lang=js"
export * from "./MessageNotice.vue?vue&type=script&setup=true&name=MessageNotice&lang=js"

import "./MessageNotice.vue?vue&type=style&index=0&id=4aaea9c7&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aaea9c7"]])

export default __exports__